const initialState = {};

export default function action(state = initialState, action) {

    let newState = naiveShallowCopy(state);

    switch (action.type) {

        case "FB_ADD_QUESTION":

            newState[action.form].push(action.payload);

            return newState;
        case "FB_SET_QUESTIONS":
            newState[action.form] = action.payload;

            return newState;
        case "FB_REMOVE_QUESTION":

            newState[action.form] = newState[action.form].filter(item => {
                return item.id !== action.payload.id;
            });

            return newState;
        case "FB_CHANGE_QUESTION":

            const index = newState[action.form].findIndex(element => {
                return element.id === action.payload.id
            });

            newState[action.form][index] = action.payload;

            return newState;
        case "FB_CLEAR_QUESTIONS":
            //return [];
            return newState;
        default:
            return state;
    }
}

/**
 * This function will copy object without any reference
 * so in our case, redux will detect change, since it does not
 * detect changes in nested objects, like our data is
 *
 * @param original
 * @returns {{}}
 */
function naiveShallowCopy(original) {
    let clone = {};
    let key;
    for (key in original) {
        clone[key] = original[key];
    }
    return clone;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/form-builder/questions.js